module.exports = __webpack_public_path__ + "static/p09_pajaroLvolandoAlaR-10764e5e054a5e0a8ad554c05317fcc0.png";